import { ChipField, ReferenceArrayField, ReferenceFieldProps, SingleFieldList, usePermissions, useRecordContext } from "react-admin";
import { PERMISSIONS } from "../../constants";
import { SxProps } from "@mui/material/styles";
import { Typography } from "@mui/material";

type PermissionValue = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

type IReferenceFieldWithLimit = ReferenceFieldProps & {
  sxChip?: SxProps,
  permission?: PermissionValue,
  name: string,
}

const ReferenceArrayFieldWithLimit = ({ label, source, link = false, permission, reference, sxChip = {}, name }: IReferenceFieldWithLimit) => {
  const { permissions } = usePermissions();
  const record = useRecordContext();
  if (!record) { return null; }
  let values: string[] = [];

  if (Array.isArray(record[source])) {
    values = Object.values(record[source]);
  }

  return (
    <>
      <ReferenceArrayField label={label} record={{ ...record, [source]: values.slice(0, 4) }} source={source} reference={reference}>
        <SingleFieldList linkType={permissions && permissions.includes(permission) && link}>
          <ChipField sx={sxChip} source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      {
        values.length > 4 &&
        <Typography variant="subtitle2" sx={{ paddingTop: 1, paddingLeft: 1 }}>mais {values.length - 4} {name}{values.length - 4 > 1 ? 's' : ''}</Typography>
      }
    </>);
};

export default ReferenceArrayFieldWithLimit;
